import axios from 'axios'

// token 请求
export const requestToken = () => {
  return axios.request({
    method: 'get',
    url: '/v2/donate/token'
  })
}

export const checkLogin = () => {
  return axios.post('/v2/checkLogin')
}

export const getItemList = (data) => {
  return axios.request({
    method: 'post',
    url: '/api/v2/donate/projects',
    params: data
  })
}

// 登录
export const login = (user) => {
  return axios.post('/api/v2/login', user)
}

export const register = (user, key, captcha) => {
  return axios.post('/api/v2/register', {
    user: user,
    key: key,
    captcha: captcha
  })
}

export const goToPay = (data) => {
  return axios.request({
    method: 'post',
    url: '/api/v2/donate/order',
    params: {
      api_token: data.token,
      project: data.project,
      amount: data.amount,
      is_invoice: data.invoice,
      name: data.name,
      phone: data.phone,
      address: data.address,
      email: data.email,
      channel: data.channel,
      locale: data.locale,
      register_no: data.registeNumber,
      register_country: data.country,
      register_date: data.registerDate,
      auth_name: data.authName,
      region: data.region,
      passport_no: data.passportNumber,
      passport_start_date: data.passportStartDate,
      passport_end_date: data.passportExpiryDate,
      username: data.username
    }
  })
}

export const getInformation = (data) => {
  return axios.request({
    method: 'post',
    url: '/api/v2/donate/info',
    params: data
  })
}

export const getLangJsonBody = (file) => {
  return axios.request({
    method: 'get',
    url: file
  })
}
export const queryOrder = (data) => {
  return axios.request({
    method: 'post',
    url: '/api/v2/donate/query',
    params: data
  })
}
export const getVerfication = (data) => {
  return axios.request({
    method: 'post',
    url: '/api/v2/donate/verfication',
    params: {
      _token: data.token,
      tel: data.tel
    }
  })
}

export const checkVerfiation = (data) => {
  return axios.request({
    method: 'post',
    url: '/api/v2/donate/checkVerfication',
    params: data
  })
}

export const getCaptcha = (data) => {
  return axios.request({
    method: 'get',
    url: '/api/v2/donate/getCaptcha'
  })
}

export const checkCaptcha = (data) => {
  return axios.request({
    method: 'post',
    url: '/v2/donate/checkCaptcha',
    params: {
      _token: data.token,
      captcha: data.captcha
    }
  })
}

/*
* 检查登录
* */
export async function getResponse (request, success, error = null, logName = null) {
  request.then(res => {
    let code = res.data.code
    let msg = res.data.msg
    if (logName != null) {
      console.log(name, res.data)
    }
    if (code === '200') {
      let data = res.data
      success(data)
    } else {
      if (error != null) {
        error()
      }
      alert(msg)
    }
  })
}



// WEBPACK FOOTER //
// ./src/api.js